import api from './api';

export async function getAdminConfig() {
    const r = await api.get('/admin/config');
    return r.data.config;
}
export async function updateAdminConfig(partial) {
    const r = await api.put('/admin/config', partial);
    return r.data.config;
}
export async function getMetrics() {
    const r = await api.get('/admin/metrics');
    return r.data;
}
export async function listUsers(params = {}) {
    const r = await api.get('/admin/users', { params });
    return r.data;
}
export async function patchUser(id, payload) {
    const r = await api.patch(`/admin/users/${id}`, payload);
    return r.data.user;
}
export async function deleteUser(id) {
    await api.delete(`/admin/users/${id}`);
}
export async function listFamilies() {
    const r = await api.get('/admin/families');
    return r.data.families || [];
}
export async function previewAudience(type, value) {
    const params = { type };
    if (value) params.value = value;
    const r = await api.get('/admin/audiences/preview', { params });
    return r.data.count;
}
export async function sendBroadcast(payload) {
    const r = await api.post('/admin/broadcasts', payload);
    return r.data.broadcast;
}
export async function listBroadcasts() {
    const r = await api.get('/admin/broadcasts');
    return r.data.broadcasts || [];
}
